import * as _ from 'lodash'
import { copyObject } from "../../../utils";

import { FilterDocuments } from './Filters/FilterDocuments';
import { FilterEstimate } from './Filters/FilterEstimate';
import { FilterFinancial } from './Filters/FilterFinancial';
import { FilterInvoice } from './Filters/FilterInvoice'
import { FilterPayments } from './Filters/FilterPayments';

import { JobT } from '../../../types/Job';
import moment from 'moment';

export interface ItemFilterJob {
    callback(Job): JobT
    priority: number
    name: string
}

const Filters: Array<ItemFilterJob> = [
    FilterDocuments,
    FilterEstimate,
    // FilterPayments,
    // FilterCrewWorker,
    FilterFinancial,
    FilterInvoice,
]

const cloneFiltersJob = Object.assign([], Filters);
const sortFilters = _.sortBy(cloneFiltersJob, [function (item) { return item.priority; }]);
// parseJob
export const JobApplyFilters = (job: JobT): JobT => {
    let timeData = {
        startTime: new Date(),
        endTime: null
    }

    let startTime = moment()


    let cloneJob = copyObject(job)
    // console.log("sortFilters", sortFilters)
    // console.log("cloneJob", cloneJob)
    sortFilters.map((item, index) => {
        // let timeDataFilter = {
        //     startTime: new Date(),
        //     endTime: null
        // }

        console.log(`JobApplyFilters->before->${item.priority}->${item.name}: `, cloneJob.financial.revenue)
        // cloneJob = _.cloneDeep(item.callback(cloneJob))
        cloneJob = item.callback(cloneJob)
        // timeDataFilter.endTime = new Date()
        // console.log(`JobApplyFilters->${item.name}->duration: `, `${moment(timeDataFilter.endTime).diff(timeDataFilter.startTime, 'millisecond')}`)
        // console.log(`JobApplyFilters->${item.priority}->${item.name}: `, cloneJob.financial.revenue)
    })

    // timeData.endTime = new Date()
    // console.log("JobApplyFilters-duration", `${moment(timeData.endTime).diff(timeData.startTime, 'millisecond')}`)
    // console.log("cloneJob->parseJob", cloneJob.payments)
    return cloneJob;
}